import { ADD_POST, GET_POST, DELETE_POST,REFETCH_POSTS,UPDATE_POST,EMPTY_LIST } from '../Actions/actionTypes';

const initial = {
  LocalFeedList: [],
  TotalCounts:0,
  IsFetchingPost:false
};

export default (state=initial,action)=>{
    switch(action.type){
        case ADD_POST:
            let addNewPost={...state};
            addNewPost.LocalFeedList.unshift({PostComment:action.payload.postComment,LocalFeedImage:action.payload.image,isImage:action.payload.isImage,FeedId:action.payload.FeedId});
            return addNewPost;
        case GET_POST:
            if(state.TotalCounts<action.payload.TotalCounts) {
                return {
                    ...state,
                    IsFetchingPost: true,
                    TotalCounts: action.payload.TotalCounts,
                    LocalFeedList: state.LocalFeedList.concat(action.payload.LocalFeedList)
                };
            }
            else{
                return{
                    ...state,
                    IsFetchingPost: true,
                    TotalCounts: action.payload.TotalCounts,
                }
            }
      case REFETCH_POSTS:
          return {
            ...state,
            IsFetchingPost:false
          };
      case DELETE_POST:
            let deletePost={...state};
            let arr={};
            arr['LocalFeedList']=deletePost.LocalFeedList.filter((post)=>post.FeedId!==action.payload.FeedId);
            return {...arr, IsFetchingPost:true,
              TotalCounts:state.TotalCounts-1};

      case UPDATE_POST:
        let updatePost={...state};
        let index=updatePost.LocalFeedList.findIndex((post)=>post.FeedId===action.payload.FeedId);
        updatePost.LocalFeedList[index]["PostComment"]=action.payload.postComment;
        return {...updatePost,TotalCounts:state.TotalCounts};
      case EMPTY_LIST:
        return initial;
        default:
            return state;
    }
}